import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество`,
    content: {
      description: `<p>Набор пенал на 4 шоколадки.<br>Размер: 100х100х10мм / Вес: 20 г<br>Наполнение: 4 шоколадки по 5 г</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
